export default "__VITE_ASSET__rOxSHWka__"